import { render, staticRenderFns } from "./IndexSTP.vue?vue&type=template&id=ea6d2fc0&"
import script from "./IndexSTP.vue?vue&type=script&lang=js&"
export * from "./IndexSTP.vue?vue&type=script&lang=js&"
import style0 from "./IndexSTP.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./IndexSTP.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports